import OCJouney from '../../assets/selectiveJOurney.png'
import { Link } from "react-router-dom";

export default function SelectiveJourney() {
    return (
        <div className="bg-blue-50 min-h-screen py-10 sm:py-20 px-4 sm:px-6 md:px-10">
            <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold text-purple-800">
                Selective Journey
            </h2>

            <p className="text-base sm:text-lg md:text-xl text-gray-700 px-4 sm:pl-6 sm:pr-4 md:pl-16 md:pr-10 mt-6 sm:mt-6 mb-2">
                <span className="font-bold text-yellow-500">Unlock Your Child's Potential!</span>
                <br /><br />
                Is your child in <span className="font-bold text-teal-600">Year 5</span> or <span className="font-bold text-teal-600">Year 6</span> and preparing for the <span className="font-bold text-yellow-500">Selective School Placement Test</span> or scholarship exams? Our program is designed to provide the structured support they need to excel.
                <br /><br />
                Whether they're just starting their journey or are in the final stages of preparation, our comprehensive approach combines targeted practice with realistic mock tests. This is the perfect way to enhance their confidence and readiness for the challenges ahead.
                <br /><br />
                Don't leave your child's future to chance! Enroll now in a program that has consistently helped students achieve outstanding results. Give them the best opportunity for success—secure their spot today!
            </p>

            <div className="bg-blue-50 pt-8 sm:pt-14 pb-6 sm:pb-8 px-4 sm:px-6 md:px-10">
                <div className="max-w-7xl mx-auto">
                    {/* Three column layout for cards and center image */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 items-center">

                        {/* Left Card - Practice Questions */}
                        <div className="p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-yellow-100 via-yellow-50 to-yellow-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-6 md:border-l-8 border-yellow-400 space-y-3 sm:space-y-4">

                            <h4 className="text-xl sm:text-2xl font-semibold text-yellow-700">
                                Practice -a- thon
                            </h4>

                            <p className="text-sm sm:text-base text-gray-800 font-semibold">
                                Empower Your Child with Targeted Practice!
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700">
                                Our practice questions in the core areas (<span className="font-semibold">English, Mathematical Reasoning, Thinking Skills and Creative Writing</span>) aim to provide your child with the essential support needed to excel in their mock tests. Before they tackle their exams, it's crucial to ensure they have practiced sufficiently and feel confident in their abilities.
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700">
                                Witness your child's progress through our unique belt system, advancing from <span className="font-semibold">white belt to black belt in Maths</span>. This structured approach not only builds their skills but also boosts their confidence, preparing them for success in their upcoming tests.
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700 font-medium">
                                Invest in your child's future—help them master the content! Choose all 4 or start with one!
                            </p>

                            <div className="border-t border-yellow-300 pt-3 space-y-2">
                                <p className="text-sm sm:text-base font-semibold text-yellow-700">
                                    Mathematical Reasoning
                                </p>

                                <p className="text-xs sm:text-sm text-gray-700">
                                    Comprehensive Maths Practice for Year 5/6! Our program offers practice questions covering <span className="font-semibold">19 essential topics</span>. Each topic is followed by a test to ensure mastery, helping students build confidence through structured progress.
                                </p>

                                <p className="text-xs sm:text-sm text-gray-700">
                                    Available for <span className="font-bold text-green-600">$109</span> for all 19 Maths topics.
                                </p>
                            </div>

                            <ul className="list-disc pl-4 sm:pl-5 text-xs sm:text-sm text-gray-700 space-y-1 pt-2">
                                <li>
                                    <Link to="/login" className="hover:text-blue-600 hover:underline cursor-pointer">
                                        Mathematical Reasoning – <span className="font-bold text-green-600">$109</span>
                                    </Link>
                                </li>
                                <li>Thinking Skills – <span className="italic text-gray-500">Coming soon</span></li>
                                <li>English – <span className="italic text-gray-500">Coming soon</span></li>
                                <li>Creative Writing – <span className="italic text-gray-500">Coming soon</span></li>
                            </ul>

                        </div>

                        {/* Center - Ninja Image */}
                        <div className="flex justify-center items-center">
                            <img
                                src={OCJouney}
                                alt="Journey Visual"
                                className="w-full max-w-md mx-auto rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl md:shadow-2xl object-contain"
                            />
                        </div>

                        {/* Right Card - Weekly Mock Tests */}
                        <div className="p-4 sm:p-5 md:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-r from-green-100 via-green-50 to-green-100 shadow-md sm:shadow-lg border-l-4 sm:border-l-6 md:border-l-8 border-green-400 space-y-3 sm:space-y-4">

                            <h4 className="text-xl sm:text-2xl font-semibold text-green-700">
                                Mock Tests: Real Exam Preparation Made Easy!
                            </h4>

                            <p className="text-xs sm:text-sm text-gray-700">
                                Our Mock Tests aim to simulate the exam experience as closely as possible, giving your child the confidence they need to excel. When they feel prepared and ready, it's the perfect opportunity to assess their time management skills and accuracy under pressure.
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700">
                                You can choose between individual topic tests or a comprehensive Mock Test covering all four subjects. This distinctive offering from our <span className="font-semibold">Exam Warrior team</span> is designed for your child's unique learning needs, ensuring they receive the targeted practice necessary for success.
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700">
                                Each bundle consists of <span className="font-semibold">10 tests</span>, and at an affordable price of
                                <span className="font-bold text-green-600"> $99 per subject bundle</span>, this is the essential practice your child needs to thrive.
                            </p>

                            <p className="text-xs sm:text-sm text-gray-700 font-medium">
                                Prepare your child for success—enroll in our Mock Tests today!
                            </p>

                            <div className="border-t border-green-300 pt-3 space-y-2">
                                <p className="text-sm sm:text-base font-semibold text-green-700">
                                    1. Individual Subject Tests (10 tests per bundle)
                                </p>

                                <ul className="list-disc pl-4 sm:pl-5 text-xs sm:text-sm text-gray-700 space-y-1">
                                    <li>
                                        <Link to="/login" className="hover:text-blue-600 hover:underline cursor-pointer">
                                            Mathematical Reasoning – <span className="font-bold text-green-600">$99</span>
                                        </Link>
                                    </li>
                                    <li>Thinking Skills – <span className="italic text-gray-500">Coming soon</span></li>
                                    <li>English – <span className="italic text-gray-500">Coming soon</span></li>
                                    <li>Creative Writing – <span className="italic text-gray-500">Coming soon</span></li>
                                </ul>
                            </div>

                            <div className="border-t border-green-300 pt-3">
                                <p className="text-sm sm:text-base font-semibold text-green-700">
                                    2. Comprehensive Mock Test Bundle
                                </p>
                                <p className="text-xs sm:text-sm text-gray-700">
                                    10 tests encompassing all 4 key subjects.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 text-center">
                <div className="flex justify-center gap-9 flex-wrap">
                    <Link to="/exam-selection">
                        <button className="bg-yellow-400 hover:bg-orange-500 text-white font-semibold text-base sm:text-lg px-6 sm:px-8 md:px-10 py-2 sm:py-3 md:py-4 rounded-full shadow-md sm:shadow-lg transition duration-300">
                            Start Assessment
                            <i className="fas fa-arrow-right ml-2"></i>
                        </button>
                    </Link>

                    <Link to="/signup">
                        <button className="bg-purple-600 hover:bg-teal-600 text-white font-semibold text-base sm:text-lg px-6 sm:px-8 md:px-10 py-2 sm:py-3 md:py-4 rounded-full shadow-md sm:shadow-lg transition duration-300">
                            Sign Up
                            <i className="fas fa-arrow-right ml-2"></i>
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
}